// Petit chime synthétisé (Web Audio) joué à la fin d'une analyse. Pas de fichier
// asset : deux notes sinus douces, gain très faible. L'AudioContext est créé
// paresseusement et repris (resume) — l'utilisateur a déjà interagi (clic
// « Analyser ») donc les politiques d'autoplay sont satisfaites.

let ctx: AudioContext | null = null;

function getCtx(): AudioContext | null {
  try {
    const Ctor = window.AudioContext || (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
    if (!Ctor) return null;
    if (!ctx) ctx = new Ctor();
    if (ctx.state === 'suspended') void ctx.resume();
    return ctx;
  } catch {
    return null;
  }
}

/** Crée/réveille l'AudioContext pendant un geste utilisateur (clic « Analyser »).
 *  Indispensable : si on ne crée le contexte qu'à la fin de l'analyse (hors
 *  geste), les politiques d'autoplay le laissent « suspended » et aucun son ne
 *  sort. Appelé au lancement de l'analyse pour garantir un contexte « running ». */
export function primeAudio(): void {
  getCtx();
}

/** Joue un petit « ding » doux à deux notes (succès d'analyse). */
export function playChime(): void {
  const ac = getCtx();
  if (!ac) return;
  const now = ac.currentTime;
  const notes = [
    { f: 660, t: 0 },     // mi
    { f: 880, t: 0.11 },  // la (monte → sensation « prêt ! »)
  ];
  for (const { f, t } of notes) {
    const osc = ac.createOscillator();
    const gain = ac.createGain();
    osc.type = 'sine';
    osc.frequency.value = f;
    const start = now + t;
    gain.gain.setValueAtTime(0.0001, start);
    gain.gain.exponentialRampToValueAtTime(0.06, start + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, start + 0.28);
    osc.connect(gain);
    gain.connect(ac.destination);
    osc.start(start);
    osc.stop(start + 0.3);
  }
}
